export default {
  title: 'HubRise',
  setup: {
    description: 'Partilhar dados com outras aplicações.',
  },
  form: {
    is_menus_sync_enabled: 'Sincronizar menu',
    is_inventory_sync_enabled: 'Sincronizar inventário',
    is_opening_hours_sync_enabled: 'Sincronizar horário de funcionamento',
    is_order_acceptance_mode_sync_enabled: 'Sincronizar estado ocupado / pausado',
    variant_ref: 'Variante de menu',
    variant_ref_default: 'Predefinição',
  },
  tabs: {
    settings: 'Definições',
    service_types: 'Tipos de serviço',
    payments: 'Pagamentos',
    charges: 'Cobranças',
    deals: 'Ofertas',
    discounts: 'Descontos',
    customers: 'Clientes',
  },
  customers: {
    description:
      'Apagar os dados de um único cliente no HubRise, por exemplo após um pedido de eliminação de dados. Esta ação não pode ser revertida.',
    customer: 'Cliente',
    placeholder: 'Pesquisar por nome, email ou telefone…',
  },
  mapping: {
    description:
      'Mapeie cada entidade {{provider}} para o valor e nome correspondente no HubRise. Deixe uma linha vazia para usar as predefinições de {{provider}}.',
    entity: '{{provider}}',
    value: 'Valor HubRise',
    name: 'Nome HubRise',
  },
  connecting: {
    title: 'A concluir a ligação ao HubRise…',
    description: 'Isto demora alguns segundos. Por favor, mantenha esta página aberta.',
    error_title: 'A ligação ao HubRise está a demorar mais do que o esperado',
    error_description:
      'O HubRise foi autorizado, mas a ligação ainda não está confirmada. Verifique novamente em breve — se continuar a falhar, inicie a ligação novamente.',
  },
  buttons: {
    connect: 'Ligar ao HubRise',
    check_again: 'Verificar novamente',
    disconnect: 'Desligar',
    go_to_hubrise: 'Ir para o HubRise',
    pull_menus: 'Importar menu',
    pull_inventory: 'Importar inventário',
    save: 'Guardar',
    delete_customer: 'Eliminar cliente',
  },
  toasts: {
    connected: 'HubRise foi ligado',
    connect_cancelled: 'A ligação ao HubRise foi cancelada',
    connect_error: 'Falha ao iniciar a ligação ao HubRise',
    connect_timeout: 'A ligação ao HubRise ainda não pôde ser confirmada',
    local_changes_replaced:
      'As definições do HubRise foram atualizadas noutro local — as suas alterações não guardadas foram substituídas',
    disconnect_success: 'HubRise foi desligado',
    disconnect_error: 'Falha ao desligar o HubRise',
    pull_menus_success: 'A sincronização do menu foi iniciada',
    pull_menus_error: 'Falha ao importar o menu',
    pull_inventory_success: 'A sincronização do inventário foi iniciada',
    pull_inventory_error: 'Falha ao importar o inventário',
    save_success: 'As definições do HubRise foram guardadas',
    save_error: 'Falha ao guardar as definições do HubRise',
    load_customers_error: 'Falha ao carregar os clientes',
    delete_customer_success: 'A eliminação dos dados do cliente foi solicitada',
    delete_customer_error: 'Falha ao eliminar os dados do cliente',
  },
  delete_customer_confirm: {
    title: 'Eliminar este cliente do HubRise?',
    description: 'Os dados do cliente serão apagados no HubRise. Esta ação não pode ser revertida.',
    ok: 'Eliminar',
    cancel: 'Cancelar',
  },
  disconnect_confirm: {
    title: 'Desligar HubRise?',
    description: 'Isto irá parar a sincronização de menus, inventário e encomendas com o HubRise.',
    ok: 'Desligar',
    cancel: 'Cancelar',
  },
  connected: {
    title: 'Ligado ao HubRise',
    description: 'A sua conta HubRise foi ligada com sucesso.',
    account: 'Conta',
    location: 'Localização',
    catalog: 'Catálogo',
    customer_list: 'Lista de clientes',
  },
};
